// eslint-ignore
export default 
`<Toggle
  v-model="value"
  true-value="yes"
  false-value="no"
/>
<p>Value:{{ value }}</p>


export default {
  components: { Toggle },
  
  data() {
    return { 
      value: "no"
    }
  }
}`;